import React from "react"
import { Route } from "react-router-dom"

const HeaderTab = ({ path, children }) => (
  <Route
    path={path}
    render={props => React.cloneElement(children, { ...props })}
  />
)

export default HeaderTab



// WEBPACK FOOTER //
// ./src/components/HeaderTab/index.js